export default function AffiliateDisclosure() {
  return (
    <div className="container__policy">
      <h1>Affiliate Disclosure</h1>
      <p>
        AI & Tech Today participates in affiliate programs. This means we may earn a commission if you click on certain links and make a purchase, at no additional cost to you.

We only recommend tools and services that we believe may be useful to our readers. Affiliate links never influence our editorial content.

      </p>
      <p>
        Your support helps keep this site running. Thank you for reading!
      </p>
    </div>
  );
}